export const COLOUR_CONSTANTS = {
  white: "#FFFFFF",
  black: "#000000"
};
export const getPalette = mode => {
  return {
    palette: {
      mode,
      ...(mode === "light" ? {
        primary: {
          main: "#004FFF",
          light: "#3372FF",
          dark: "#21304A",
          contrastText: COLOUR_CONSTANTS.white
        },
        secondary: {
          main: "#85DDED",
          light: "#E0F6FA",
          dark: "#D3D6DB",
          contrastText: COLOUR_CONSTANTS.black
        },
        error: {
          main: "#EC6884",
          light: "#F9D4DC",
          dark: "#AD0026",
          contrastText: ""
        },
        warning: {
          main: "#FBAF99",
          light: "#FFE899",
          dark: "",
          contrastText: ""
        },
        sticky: {
          main: "",
          light: "rgba(249, 212, 220, 0.25)"
        },
        info: {
          main: "#E6EEFF",
          light: "#004FFF",
          dark: "",
          contrastText: "rgba(0,0,0,0.87)"
        },
        success: {
          main: "#265E2C",
          light: "#388E3C",
          dark: "",
          contrastText: ""
        },
        grey: {
          1: "#C1C1C1",
          2: "#919191",
          3: "#616161",
          4: "#303030"
        },
        background: {
          default: "#F9FAFC",
          paper: COLOUR_CONSTANTS.white,
          navigation: COLOUR_CONSTANTS.white,
          elevation1: COLOUR_CONSTANTS.white,
          elevation2: COLOUR_CONSTANTS.white,
          hamburger: "#C7D5F5",
          light: "#3372FF",
          shadow: "rgba(0, 0, 0, 0.15)",
          white: COLOUR_CONSTANTS.white
        },
        text: {
          primary: "rgba(0,0,0,0.87)",
          secondary: "rgba(0,0,0,0.6)",
          disabled: "rgba(0,0,0,0.38)"
        },
        link: "#01386F",
        table: {
          border: "rgba(224, 224, 224, 1)"
        },
        divider: "rgba(0,0,0,0.12)",
        thickSeperator: "3px solid #F0F1F4",
        graph: {
          blue: "rgba(24, 58, 116, 1)",
          pink: "rgba(211, 99, 143, 1)",
          yellow: "rgba(255, 195, 105, 1)"
        }
      } : {
        primary: {
          main: "#99B9FF",
          light: "#99B9FF",
          dark: COLOUR_CONSTANTS.white,
          contrastText: COLOUR_CONSTANTS.black
        },
        secondary: {
          main: "#85DDED",
          light: "#E0F6FA",
          dark: "#CCDCFF",
          contrastText: COLOUR_CONSTANTS.black
        },
        error: {
          main: "#EE7D95",
          light: "#F4A8B9",
          dark: "#F4A8B9",
          contrastText: ""
        },
        sticky: {
          main: "",
          light: "rgba(249, 212, 220, 0.1)"
        },
        warning: {
          main: "#FBAF99",
          light: "#FFE899",
          dark: "",
          contrastText: ""
        },
        info: {
          main: "#232A3A",
          light: "#99B9FF",
          dark: "",
          contrastText: COLOUR_CONSTANTS.white
        },
        success: {
          main: "#81C784",
          light: "#81C784",
          dark: "",
          contrastText: ""
        },
        grey: {
          1: "#A0A0A0",
          2: "#E9E9E9",
          3: "#E9E9E9",
          4: COLOUR_CONSTANTS.white
        },
        background: {
          default: "#121212",
          paper: "#121212",
          navigation: "#1E1E1E",
          elevation1: "#1F1F1F",
          elevation2: "#2C2C2C",
          hamburger: "#99B9FF",
          light: COLOUR_CONSTANTS.white,
          shadow: "rgba(0, 0, 0, 0.4)",
          white: COLOUR_CONSTANTS.white
        },
        text: {
          primary: COLOUR_CONSTANTS.white,
          secondary: "rgba(255, 255, 255, 0.7)",
          disabled: "rgba(255, 255, 255, 0.5)"
        },
        link: "#C5DBED",
        table: {
          border: "rgba(51, 51, 51, 1)"
        },
        divider: "#A0A0A0",
        thickSeperator: "3px solid #F0F1F4",
        graph: {
          blue: "rgba(154, 214, 255, 1)",
          pink: "rgba(211, 99, 143, 1)",
          yellow: "rgba(255, 195, 105, 1)"
        }
      })
    }
  };
};